export const PAGE_LOAD = 'PAGE_LOAD';
export const PAGE_LOADED = 'PAGE_LOADED';
